import type { ReactNode } from 'react'
import type { PopperProps as MuiPopperProps } from '@material-ui/core/Popper'
import React from 'react'
import type { BreakpointValues } from '@material-ui/core/styles/createBreakpoints'
import Popper from '@material-ui/core/Popper'
import type { Theme } from '@material-ui/core'
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import Dialog, { DialogActions, DialogContent, DialogTitle } from '../Dialog'
import IconButton from '../IconButton'

const useStyles = makeStyles<Theme, ResponsivePopperProps>(() => ({
  root: {},
  dialogRoot: {},
  dialogContent: {}
}))

export interface ResponsivePopperProps {
  classes?: ReturnType<typeof useStyles>
  open: boolean
  children: ReactNode
  footer?: ReactNode
  PopperProps?: Partial<MuiPopperProps>
  modalBreakpoint?: keyof BreakpointValues
  title?: string
  dialogOnClose?: (event: React.MouseEvent<HTMLElement>) => void
}

export default function ResponsivePopper(props: ResponsivePopperProps) {
  const { open, children, footer, PopperProps = {}, modalBreakpoint = 'xs', title, dialogOnClose } = props
  const classes = useStyles(props)
  const theme = useTheme()
  const isDialog = useMediaQuery(theme.breakpoints.down(modalBreakpoint))

  if (!isDialog) {
    return (
      <Popper className={classes.root} open={open} {...PopperProps}>
        {children}
        {footer && <div>{footer}</div>}
      </Popper>
    )
  } else {
    return (
      <Dialog classes={{ paper: classes.dialogRoot }} open={open}>
        {(title || dialogOnClose) && (
          <DialogTitle
            rightContent={
              dialogOnClose ? (
                <IconButton size="small" onClick={dialogOnClose} className={classes.closeButton}>
                  <ClearIcon />
                </IconButton>
              ) : null
            }
          >
            {title}
          </DialogTitle>
        )}
        <DialogContent className={classes.dialogContent}>{children}</DialogContent>
        {footer && <DialogActions>{footer}</DialogActions>}
      </Dialog>
    )
  }
}
